module.exports = __webpack_public_path__ + "img/right.47df1f0e.png";